// extracted by mini-css-extract-plugin
export default {"Container":"RefereeAccessForm_Container__Z1tG4","TextInput":"RefereeAccessForm_TextInput__aiS62","SubmitButton":"RefereeAccessForm_SubmitButton__fxOFK"};